module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/i18n/es.json
// module id = 9SIW
// module chunks = 37